import { FC, Fragment, useMemo } from "react";
import { Popover, PopoverOrigin, Stack } from "@mui/material";
import { FilterTreeDisabledViewButton } from "@/components/pages/common/filters-tree/filters-disabled-view/components/FilterTreeDisabledViewButton";
import { isTreeNodeFilterGroup } from "@/components/pages/common/filters-tree/utils/helpers/isTreeNodeWithIdFilterGroup";
import { FilterTreeDisabledView } from "@/components/pages/common/filters-tree/filters-disabled-view/FilterTreeDisabledView";
import { useMenuHook } from "@/utils/hooks/useMenu.hook";
import { useGetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersQuery } from "@/services/cloudchipr.api";
import { calculateFilterTreeFiltersCount } from "@/components/pages/common/filters-tree/utils/helpers/calculateFilterTreeFiltersCount";
import { addIdsToFilterTreeItems } from "@/components/pages/common/filters-tree/utils/helpers/ids-manipulations/addIdsToFilterTreeItems";
import { FilterTreeNodeWithId } from "@/components/pages/common/filters-tree/utils/types/common";

interface CostAllocationMetadataInCategoryEditFiltersProps {
  filterTree: FilterTreeNodeWithId;
}

export const CostAllocationMetadataInCategoryEditFilters: FC<
  CostAllocationMetadataInCategoryEditFiltersProps
> = ({ filterTree }) => {
  const { open, openMenu, closeMenu, anchor } = useMenuHook();

  const { data, isLoading } =
    useGetUsersMeOrganisationsCurrentResourceExplorerPossibleFiltersQuery({});

  const filtersCount = useMemo(() => {
    if (!filterTree) {
      return;
    }
    return calculateFilterTreeFiltersCount(addIdsToFilterTreeItems(filterTree));
  }, [filterTree]);

  return (
    <Fragment>
      <FilterTreeDisabledViewButton
        disabled={isLoading}
        filtersCount={filtersCount}
        onClick={openMenu}
      />

      <Popover
        open={open}
        anchorEl={anchor}
        onClose={closeMenu}
        slotProps={slotProps}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        <Stack maxHeight="60dvh" p={1.5}>
          {data && isTreeNodeFilterGroup(filterTree) && (
            <FilterTreeDisabledView
              filterTree={filterTree}
              possibleFilters={data}
            />
          )}
        </Stack>
      </Popover>
    </Fragment>
  );
};

const slotProps = {
  paper: { sx: { p: 0 } },
};

const anchorOrigin: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "right",
};

const transformOrigin: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};
